import React from 'react';
import AuthLayout from '../../layouts/AuthLayout';
import ForgotPassword from '../../components/Auth/ForgotPassword';

const ForgotPasswordPage = () => {
	return (
		<AuthLayout>
			<ForgotPassword />
		</AuthLayout>
	);
};

export default ForgotPasswordPage;
